import PropTypes from 'prop-types'

import { STRING } from 'resources'

import ReklaimModal, { ModalHeader, ModalBody, ModalTitle } from 'components/ReklaimModal'

import {
  NetworkFeeModalDescription,
  NetworkFeeModalButton,
} from 'screens/Wallet/WalletRedemptions/CryptoRedemption/styles'

const NetworkFeeModalExplainer = ({ isModalNetworkFeeOpen, handleCloseNetworkFeeModal }) => (
  <ReklaimModal isOpen={isModalNetworkFeeOpen} centered>
    <ModalHeader toggle={handleCloseNetworkFeeModal} />
    <ModalBody>
      <ModalTitle>{STRING.cryptoRedeemScreen.confirmationScreen.infoModal.title}</ModalTitle>
      <NetworkFeeModalDescription>
        {STRING.cryptoRedeemScreen.confirmationScreen.infoModal.description}
      </NetworkFeeModalDescription>
      <NetworkFeeModalButton onPress={handleCloseNetworkFeeModal}>
        {STRING.cryptoRedeemScreen.confirmationScreen.infoModal.buttonText}
      </NetworkFeeModalButton>
    </ModalBody>
  </ReklaimModal>
)

NetworkFeeModalExplainer.propTypes = {
  isModalNetworkFeeOpen: PropTypes.bool.isRequired,
  handleCloseNetworkFeeModal: PropTypes.func.isRequired,
}

export default NetworkFeeModalExplainer
